import request from '@/axios'
import type { UserType, LoginResponseType, RoleResponseType } from './types'
// import { useStorage } from '@/hooks/web/useStorage'

// const { getStorage } = useStorage('localStorage')

interface RoleParams {
  roleName: string
}

export const loginApi = (data: UserType): Promise<IResponse<LoginResponseType>> => {
  return request.post({ url: '/login', data })
}

export const resetPassword = (tel: string): Promise<IResponse<any>> => {
  const data = { phone: tel }
  return request.post({ url: '/resetpwd', data })
}

export const setPassword = (id: string, password: string): Promise<IResponse<any>> => {
  const data = { id: id, password: password }
  return request.post({ url: '/setpwd', data })
}

export const getUserRole = (data: any): Promise<IResponse<RoleResponseType>> => {
  // data.token = getStorage('token')
  return request.post({ url: '/roles', data })
}

export const loginOutApi = (): Promise<IResponse> => {
  // return request.get({ url: '/mock/user/loginOut' })
  return new Promise<IResponse>((resolve) => {
    const ret = { status: 0, code: 0, data: 0 }
    resolve(ret)
  })
}

export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/mock/role/list', params })
}

export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
  return request.get({ url: '/mock/role/list2', params })
}

export const updateSelfInfo = (data: any): Promise<IResponse<any>> => {
  return request.post({ url: '/updateSelfInfo', data })
}

export const setLang = (data: any): Promise<IResponse<any>> => {
  return request.post({ url: '/setLang', data })
}

export const modifyPassword = (data: any): Promise<IResponse<any>> => {
  return request.post({ url: '/modifyPassword', data })
}
